import React, { useState } from 'react';
import { Box, Button, Link } from '@hover/blueprint';
import { Flex } from '@chakra-ui/react';
import { DownloadAppModal } from '@hover/shared-components';

const HeroButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <>
      <DownloadAppModal isOpen={isOpen} onClose={toggleModal} />
      <Flex direction={{ base: 'column', tablet: 'row' }}>
        <Button
          onClick={toggleModal}
          size="large"
          mr={{ base: 0, tablet: 300 }}
          mb={{ base: 300, tablet: 0 }}
          w={{ base: '323px', tablet: 'auto' }}
        >
          TRY IT ON YOUR HOME
        </Button>
        <Box as={Link} isMinimal href="/homeowner-designs/">
          <Button
            fill="outline"
            textColor="white"
            size="large"
            w={{ base: '323px', tablet: 'auto' }}
          >
            START DESIGNING NOW
          </Button>
        </Box>
      </Flex>
    </>
  );
};

export default HeroButton;
